import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaiwan = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	width: 256,
	height: 256,
	viewBox: "0 0 256 256",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		style: {
			stroke: "none",
			strokeWidth: 0,
			strokeDasharray: "none",
			strokeLinecap: "butt",
			strokeLinejoin: "miter",
			strokeMiterlimit: 10,
			fill: "none",
			fillRule: "nonzero",
			opacity: 1
		},
		transform: "matrix(2.81 0 0 2.81 1.4 1.4)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "round",
				d: "M83 21A45.2 45.2 0 0 0 49.6.1a45.4 45.4 0 0 0-25.6 5l-2 1.1A45 45 0 1 0 83 21z",
				style: {
					stroke: "none",
					strokeWidth: 1,
					strokeDasharray: "none",
					strokeLinecap: "butt",
					strokeLinejoin: "miter",
					strokeMiterlimit: 10,
					fill: "#fe0000",
					fillRule: "nonzero",
					opacity: 1
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "round",
				d: "M45 0a44.7 44.7 0 0 0-23 6.3A45 45 0 0 0 0 45h45V.1z",
				style: {
					stroke: "none",
					strokeWidth: 1,
					strokeDasharray: "none",
					strokeLinecap: "butt",
					strokeLinejoin: "miter",
					strokeMiterlimit: 10,
					fill: "#000095",
					fillRule: "nonzero",
					opacity: 1
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m32.6 23.9 5-5-6.8 1.8 1.8-6.8-5 5-1.8-6.8-1.8 6.8-5-5 1.9 6.8-6.8-1.8 4.9 5-6.7 1.8 6.7 1.8-4.9 5 6.8-1.9-1.9 6.8 5-4.9 1.8 6.8 1.8-6.8 5 4.9-1.8-6.8 6.8 1.9-5-5 6.8-1.8z",
				style: {
					stroke: "none",
					strokeWidth: 1,
					strokeDasharray: "none",
					strokeLinecap: "butt",
					strokeLinejoin: "miter",
					strokeMiterlimit: 10,
					fill: "#fff",
					fillRule: "nonzero",
					opacity: 1
				}
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 25.8,
				cy: 25.7,
				r: 7.2,
				style: {
					stroke: "none",
					strokeWidth: 1,
					strokeDasharray: "none",
					strokeLinecap: "butt",
					strokeLinejoin: "miter",
					strokeMiterlimit: 10,
					fill: "#fff",
					fillRule: "nonzero",
					opacity: 1
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "round",
				d: "M25.8 33.4a7.7 7.7 0 1 1 0-15.4 7.7 7.7 0 0 1 0 15.4zm0-14.5a6.8 6.8 0 1 0 0 13.6 6.8 6.8 0 0 0 0-13.6z",
				style: {
					stroke: "none",
					strokeWidth: 1,
					strokeDasharray: "none",
					strokeLinecap: "butt",
					strokeLinejoin: "miter",
					strokeMiterlimit: 10,
					fill: "#000095",
					fillRule: "nonzero",
					opacity: 1
				}
			})
		]
	})
});
export default SvgTaiwan;
